import { render } from "./vsharedvceopenclose.vue?vue&type=template&id=2a6bc7fa&scoped=true"
import script from "./vsharedvceopenclose.vue?vue&type=script&lang=js"
export * from "./vsharedvceopenclose.vue?vue&type=script&lang=js"

import "./vsharedvceopenclose.vue?vue&type=style&index=0&id=2a6bc7fa&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6bc7fa"]])

export default __exports__